import store from '@/store'

export const DefaultStoreActions = (RepositoryInstance) => {

    const get = ({ commit }, ctx={}) => {
        const { id, params } = ctx
        return new Promise((resolve, reject) => {
            RepositoryInstance.get(id, params)
                .then((response) => resolve(response))
                .catch((error) => reject(error))
        })
    };

    const create = ({ commit }, ctx={}) => {
        const { data, params } = ctx
        return new Promise((resolve, reject) => {
            RepositoryInstance.create(data, params)
                .then((response) => resolve(response))
                .catch((error) => reject(error))
        })
    };

    const update = ({ commit }, ctx={}) => {
        const { id, data, params } = ctx
        return new Promise((resolve, reject) => {
            RepositoryInstance.update(id, data, params)
                .then((response) => resolve(response))
                .catch((error) => reject(error))
        })
    };

    const remove = ({ commit }, id) => {
        return new Promise((resolve, reject) => {
            RepositoryInstance.delete(id)
                .then((response) => resolve(response))
                .catch((error) => reject(error))
        })
    };

    return {
        get,
        create,
        update,
        remove
    }
}

export const InterfaceToDefaultStoreActions = () => {

    const fetchData = (ctx={}, on_success=null, on_err=null, on_final=null) => {
        const { url, id, params } = ctx
        store
            .dispatch(url, { id: id, params: params})
            .then((response) => on_success ? on_success(response.data) : null)
            .catch((err) => on_err ? on_err(err) : null)
            .finally((response) => on_final ? on_final(response) : null)
    };

    const addData = (ctx={}, on_success=null, on_err=null, on_final=null) => {
        const { url, data, params } = ctx
        store
            .dispatch(url, { data: data, params: params })
            .then((response) => on_success ? on_success(response.data) : null)
            .catch((err) => on_err ? on_err(err) : null)
            .finally((response) => on_final ? on_final(response) : null)
    };

    const updateData = (ctx={}, on_success=null, on_err=null, on_final=null) => {
        const { url, id, data, params } = ctx
        store
            .dispatch(url, { id: id, data: data, params: params })
            .then((response) => on_success ? on_success(response.data) : null)
            .catch((err) => on_err ? on_err(err) : null)
            .finally((response) => on_final ? on_final(response) : null)
    };

    const deleteData = (ctx={}, on_success=null, on_err=null, on_final=null) => {
        const { url, id, params } = ctx
        store
            .dispatch(url, id)
            .then((response) => on_success ? on_success(response.data) : null)
            .catch((err) => on_err ? on_err(err) : null)
            .finally((response) => on_final ? on_final(response) : null)
    };

    return {
        fetchData,
        addData,
        updateData,
        deleteData
    }
}
